
export const APP_NAME = "Ember Fire";